<script>
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import mxPlanCommon from '@/plans/LARGE_MEETING/mixin';
import { planTypes } from '@/common/constants';

export default {
  ...createEditDeltaComponent({
    name: 'EditDelta',
    planType: planTypes.LARGE_MEETING,
    mixin: mxPlanCommon,
    withReplenish: true,
    className: 'opc-lm-edit',
    hideConfigDescription: true,
  }),
  data() {
    return {
      // ! note: the title in mxPlanCommon is replaced by replenishMixin
      title: this.$t('billing.large_meeting.title'),
      viewCurrentDialog: null,
      msgInstance: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.opc-lm-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
